module.exports = __webpack_public_path__ + "img/FB_logo_header.dff05018.svg";